"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.function.name");

var _installPower = require("@/api/cms/installPower");

var _multiUserSelect = _interopRequireDefault(require("@/views/cms/common/multiUserSelect"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'PowerManagement',
  components: {
    UserSelect: _multiUserSelect.default
  },
  data: function data() {
    var _this = this;

    return {
      searchLoading: false,
      tableLoading: false,
      searchDate: '',
      dialogVisible: false,
      isEdit: false,
      showUserSelect: false,
      form: {
        id: null,
        userId: '',
        userName: '',
        taskDate: '',
        taskTime: '上午',
        status: 0,
        remark: ''
      },
      rules: {
        userId: [{
          required: true,
          message: '请选择安装师傅',
          validator: function validator(rule, value, callback) {
            if (_this.installerUserList.length === 0) {
              callback(new Error('请选择安装师傅'));
            } else {
              callback();
            }
          },
          trigger: 'submit'
        }],
        taskDate: [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        taskTime: [{
          required: true,
          message: '请选择时段',
          trigger: 'change'
        }]
      },
      searchForm: {
        keyword: ''
      },
      statistics: {
        totalInstallers: 0,
        availableInstallers: 0,
        todayOrders: 0,
        pendingOrders: 0
      },
      tableData: [],
      total: 0,
      pagination: {
        page: 1,
        pageSize: 10
      },
      installerLoading: false,
      installerList: [],
      installerTotal: 0,
      installerPagination: {
        page: 1,
        pageSize: 10
      },
      installerSearchDate: '',
      installerUserList: [],
      installerUserNames: [],
      installerUserIds: [],
      scheduleLoading: false,
      scheduleSearchDate: '',
      scheduleList: [],
      scheduleTotal: 0,
      schedulePagination: {
        page: 1,
        pageSize: 10
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.isEdit ? '编辑安装' : '新增安装';
    },
    tableHeight: function tableHeight() {
      return document.documentElement.clientHeight * 0.6;
    },
    scheduleDateRange: function scheduleDateRange() {
      var base = this.scheduleSearchDate || this.getToday();
      var dates = [];
      var start = new Date(base);

      for (var i = 0; i < 7; i++) {
        var d = new Date(start);
        d.setDate(d.getDate() + i);
        var key = this.formatDate(d);
        dates.push({
          key: key,
          label: key
        });
      }

      return dates;
    },
    pagedScheduleList: function pagedScheduleList() {
      var start = (this.schedulePagination.page - 1) * this.schedulePagination.pageSize;
      return this.scheduleList.slice(start, start + this.schedulePagination.pageSize);
    }
  },
  watch: {
    installerSearchDate: function installerSearchDate() {
      this.loadInstallerList();
    },
    scheduleSearchDate: function scheduleSearchDate() {
      this.loadScheduleList();
    }
  },
  mounted: function mounted() {
    this.searchDate = this.getToday();
    this.loadStatistics();
    this.loadInstallerList();
    this.loadScheduleList();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.$nextTick(function () {});
    },
    handleSearch: function handleSearch() {
      this.pagination.page = 1;
      this.loadData();
      this.loadInstallerList();
    },
    resetSearch: function resetSearch() {
      this.searchForm.keyword = '';
      this.searchDate = '';
      this.loadData();
      this.loadInstallerList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.loadData();
    },
    loadData: function loadData() {
      var _this2 = this;

      this.tableLoading = true;
      var params = {
        page: this.pagination.page - 1,
        size: this.pagination.pageSize,
        taskDate: this.searchDate
      };

      if (this.searchForm.keyword) {
        params.keyword = this.searchForm.keyword;
      }

      (0, _installPower.getInstallPowerList)(params).then(function (response) {
        if (response.code === 200) {
          _this2.tableData = response.data.content || [];
          _this2.total = response.data.totalElements || 0;
        }

        _this2.tableLoading = false;
      }).catch(function () {
        _this2.tableLoading = false;
      });
    },
    loadStatistics: function loadStatistics() {
      var _this3 = this;

      (0, _installPower.getInstallPowerStatistics)().then(function (response) {
        if (response.code === 200) {
          var data = response.data;
          _this3.statistics = {
            totalInstallers: data.totalInstallers || 0,
            availableInstallers: data.availableInstallers || 0,
            todayOrders: data.todayOrders || 0,
            pendingOrders: data.pendingOrders || 0
          };
        }
      }).catch(function () {});
    },
    loadInstallerList: function loadInstallerList() {
      var _this4 = this;

      this.installerLoading = true;
      var params = {
        page: this.installerPagination.page - 1,
        size: this.installerPagination.pageSize
      };

      if (this.installerSearchDate) {
        params.taskDate = this.installerSearchDate;
      }

      if (this.searchForm.keyword) {
        params.keyword = this.searchForm.keyword;
      }

      (0, _installPower.getInstallPowerList)(params).then(function (response) {
        if (response.code === 200) {
          _this4.installerList = response.data.content || [];
          _this4.installerTotal = response.data.totalElements || 0;
        }

        _this4.installerLoading = false;
      }).catch(function () {
        _this4.installerLoading = false;
      });
    },
    handleInstallerSizeChange: function handleInstallerSizeChange(val) {
      this.installerPagination.pageSize = val;
      this.loadInstallerList();
    },
    handleInstallerCurrentChange: function handleInstallerCurrentChange(val) {
      this.installerPagination.page = val;
      this.loadInstallerList();
    },
    handleAdd: function handleAdd() {
      var _this5 = this;

      this.isEdit = false;
      this.form = {
        id: null,
        userId: '',
        userName: '',
        taskDate: this.getToday(),
        taskTime: '上午',
        status: 0,
        remark: ''
      };
      this.installerUserList = [];
      this.installerUserNames = [];
      this.installerUserIds = [];
      this.$nextTick(function () {
        _this5.$refs.form && _this5.$refs.form.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleEditInstaller: function handleEditInstaller(row) {
      var _this6 = this;

      this.isEdit = true;
      this.form = {
        id: row.id,
        userId: '',
        userName: row.userName,
        taskDate: row.taskDate,
        taskTime: this.formatTaskTime(row.taskTime),
        status: row.status,
        remark: row.remark || ''
      };
      this.$nextTick(function () {
        _this6.$refs.form && _this6.$refs.form.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleDeleteInstaller: function handleDeleteInstaller(row) {
      var _this7 = this;

      this.$confirm("\u786E\u8BA4\u5220\u9664\u5B89\u88C5\u5E08\u5085\u300C".concat(row.userName, "\u300D\u7684\u8FD0\u529B\u8BB0\u5F55\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _installPower.deleteInstallPower)(row.id).then(function (response) {
          if (response.code === 200) {
            _this7.$message.success('删除成功');

            _this7.loadInstallerList();

            _this7.loadScheduleList();
          } else {
            _this7.$message.error(response.msg || '删除失败');
          }
        }).catch(function () {
          _this7.$message.error('删除失败');
        });
      }).catch(function () {});
    },
    handleDeleteScheduleUser: function handleDeleteScheduleUser(row) {
      var _this8 = this;

      this.$confirm("\u786E\u8BA4\u5220\u9664\u5B89\u88C5\u5E08\u5085\u300C".concat(row.name, "\u300D\u7684\u6240\u6709\u6392\u73ED\u8BB0\u5F55\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _installPower.deleteInstallPowerByUser)(row.userId).then(function (response) {
          if (response.code === 200) {
            _this8.$message.success('删除成功');

            _this8.loadInstallerList();

            _this8.loadScheduleList();
          } else {
            _this8.$message.error(response.msg || '删除失败');
          }
        }).catch(function () {
          _this8.$message.error('删除失败');
        });
      }).catch(function () {});
    },
    submitForm: function submitForm() {
      var _this9 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          var taskTime = _this9.convertTaskTime(_this9.form.taskTime);

          if (_this9.isEdit) {
            var data = {
              id: _this9.form.id,
              taskDate: _this9.form.taskDate,
              taskTime: taskTime,
              status: _this9.form.status,
              remark: _this9.form.remark
            };
            (0, _installPower.updateInstallPower)(data).then(function (response) {
              if (response.code === 200) {
                _this9.$message.success('编辑成功');

                _this9.dialogVisible = false;

                _this9.loadInstallerList();

                _this9.loadScheduleList();
              } else {
                _this9.$message.error(response.msg || '编辑失败');
              }
            }).catch(function () {});
          } else {
            var _data = {
              userIds: _this9.installerUserIds,
              taskDate: _this9.form.taskDate,
              taskTime: taskTime,
              remark: _this9.form.remark
            };
            (0, _installPower.createInstallPower)(_data).then(function (response) {
              if (response.code === 200) {
                _this9.$message.success('新增成功');

                _this9.dialogVisible = false;

                _this9.loadInstallerList();

                _this9.loadScheduleList();
              } else {
                _this9.$message.error(response.msg || '新增失败');
              }
            }).catch(function () {});
          }
        }
      });
    },
    onUserSelect: function onUserSelect() {
      this.$refs.userSelect.selectType = '安装';
      this.$refs.userSelect.nickNames = this.installerUserList;
      this.$refs.userSelect.userNames = this.installerUserNames;
      this.$refs.userSelect.isFirst = true;
      this.showUserSelect = true;
      this.$refs.userSelect.getDeptDatas('安装');
    },
    onUserSelectClose: function onUserSelectClose() {
      this.showUserSelect = false;
    },
    selectUserCallBack: function selectUserCallBack(user) {
      this.installerUserList = user.nickNames;
      this.installerUserNames = user.userNames;
      var selections = this.$refs.userSelect.crud.selections || [];
      this.installerUserIds = selections.map(function (item) {
        return item.id;
      });
      this.showUserSelect = false;
    },
    handleEdit: function handleEdit(row) {
      console.log('编辑', row);
    },
    handleDelete: function handleDelete(row) {
      var _this10 = this;

      this.$confirm('确认删除该记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this10.$message.success('删除成功');

        _this10.loadData();
      }).catch(function () {});
    },
    loadScheduleList: function loadScheduleList() {
      var _this11 = this;

      this.scheduleLoading = true;
      this.schedulePagination.page = 1;
      var params = {
        page: 0,
        size: 200
      };

      if (this.scheduleSearchDate) {
        params.createDate = this.scheduleSearchDate;
      }

      (0, _installPower.getInstallPowerSevenDay)(params).then(function (response) {
        if (response.code === 200) {
          _this11.buildScheduleData(response.data.content || []);
        }

        _this11.scheduleLoading = false;
      }).catch(function () {
        _this11.scheduleLoading = false;
      });
    },
    buildScheduleData: function buildScheduleData(data) {
      var _this12 = this;

      var scheduleData = [];
      data.forEach(function (user) {
        var row = {
          name: user.userName,
          userId: user.userId
        };
        var powers = user.powers || [];

        _this12.scheduleDateRange.forEach(function (dateItem) {
          var amKey = dateItem.key + '_上午';
          var pmKey = dateItem.key + '_下午';
          var amStatus = '空闲';
          var pmStatus = '空闲';
          var amInstallTimes = [];
          var pmInstallTimes = [];
          powers.forEach(function (power) {
            var powerDate = _this12.formatDate(power.taskDate);

            if (powerDate !== dateItem.key) return;
            var taskTime = power.taskTime || '';
            var tasks = power.tasks || [];
            tasks.forEach(function (task) {
              var installDate = _this12.formatDate(task.installDate);

              if (installDate === dateItem.key && task.installTime) {
                var startHour = parseInt(task.installTime.split(':')[0], 10);

                if (startHour < 12) {
                  amInstallTimes.push(task.installTime);
                } else {
                  pmInstallTimes.push(task.installTime);
                }
              }
            });

            if (power.status === 1) {
              if (taskTime.includes('上午') || taskTime.includes('08:00-12:00')) amStatus = '休息';
              if (taskTime.includes('下午') || taskTime.includes('12:00-18:00')) pmStatus = '休息';

              if (taskTime.includes('全天') || taskTime.includes('08:00-18:00')) {
                amStatus = '休息';
                pmStatus = '休息';
              }
            } else {
              if (taskTime.includes('上午') || taskTime.includes('08:00-12:00')) amStatus = '可用';
              if (taskTime.includes('下午') || taskTime.includes('12:00-18:00')) pmStatus = '可用';

              if (taskTime.includes('全天') || taskTime.includes('08:00-18:00')) {
                amStatus = '可用';
                pmStatus = '可用';
              }
            }
          });

          if (amInstallTimes.length > 0) {
            amStatus = amInstallTimes.join(' | ');
          }

          if (pmInstallTimes.length > 0) {
            pmStatus = pmInstallTimes.join(' | ');
          }

          row[amKey] = amStatus;
          row[pmKey] = pmStatus;
        });

        scheduleData.push(row);
      });
      this.scheduleList = scheduleData;
      this.scheduleTotal = scheduleData.length;
    },
    handleScheduleSizeChange: function handleScheduleSizeChange(val) {
      this.schedulePagination.pageSize = val;
    },
    handleScheduleCurrentChange: function handleScheduleCurrentChange(val) {
      this.schedulePagination.page = val;
    },
    getScheduleClass: function getScheduleClass(status) {
      if (status === '请假') return 'schedule-leave';
      if (status === '可用') return 'schedule-available';
      if (/^\d{2}:\d{2}-\d{2}:\d{2}(\s\|\s\d{2}:\d{2}-\d{2}:\d{2})*$/.test(status)) return 'schedule-task';
      return 'schedule-idle';
    },
    convertTaskTime: function convertTaskTime(taskTime) {
      var map = {
        '上午': '08:00-12:00',
        '下午': '12:00-18:00',
        '全天': '08:00-18:00'
      };
      return map[taskTime] || taskTime;
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';
      var d = new Date(dateStr);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    formatTaskTime: function formatTaskTime(taskTime) {
      var map = {
        '08:00-12:00': '上午',
        '12:00-18:00': '下午',
        '08:00-18:00': '全天'
      };
      return map[taskTime] || taskTime;
    },
    getToday: function getToday() {
      var date = new Date();
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    }
  }
};
exports.default = _default;